
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { AdviserModel } from '@/models/adviserModel';

@Component({})
export default class ChallengerDetailAdviser extends Vue {
  @Prop({ required: true }) adviser!: AdviserModel;
  show: boolean = false;

  openPublicProfile() {
    const blankPage = this.$router.resolve(`/profile/${this.adviser.id}`);
    window.open(blankPage.href, '_blank');
  }

}
